module.exports = __webpack_public_path__ + "img/nutrition-400x300.f59d1a88.jpg";